import { render } from "./IncomingItems.vue?vue&type=template&id=c3baa4c0&scoped=true"
import script from "./IncomingItems.vue?vue&type=script&lang=js"
export * from "./IncomingItems.vue?vue&type=script&lang=js"

import "./IncomingItems.vue?vue&type=style&index=0&id=c3baa4c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3baa4c0"]])

export default __exports__